module.exports = __webpack_public_path__ + "static/media/Beedrill_gaussian2.d3e55ea8.png";